import React from "react";
import { useTheme } from "@emotion/react";

import {
  Box,
  Button,
  Heading,
  Link,
  RichText as RichTextComponent,
  VStack,
  Wrapper,
} from "components";

function HomeCloser({
  closing_button_label,
  closing_button_link,
  closing_description,
  closing_title,
}) {
  const THEME = useTheme();

  if (closing_title || closing_description) {
    return (
      <>
        {/* Solid angle scrim */}
        <Box
          width="100%"
          pb="10%"
          css={{
            background: `linear-gradient(-4deg, ${THEME.colors?.background[1]} 49.5%, transparent 50%)`,
          }}
        />

        <Wrapper
          id={closing_title && closing_title.text}
          bg="gray"
          py={{ _: "layout.5", md: "layout.6" }}
        >
          <Box>
            <VStack space="layout.3">
              {closing_title && closing_title.text && (
                <Heading children={closing_title.text} as="h2" size={700} />
              )}

              {closing_description && closing_description.html && (
                <RichTextComponent
                  html={closing_description.html}
                  size={400}
                  maxWidth="65ch"
                />
              )}
              {closing_button_link &&
                closing_button_link.url &&
                closing_button_label && (
                  <Link href={closing_button_link.url}>
                    <Button
                      children={closing_button_label}
                      appearance="primary"
                      intent="primary"
                      round={true}
                    />
                  </Link>
                )}
            </VStack>
          </Box>
        </Wrapper>
        <Box
          width="100%"
          pb="10%"
          mb="-10%"
          css={{
            transform: "rotate(180deg)",
            background: `linear-gradient(-4deg, ${THEME.colors.background[1]} 49.5%, transparent 50%)`,
          }}
        />
      </>
    );
  } else {
    return null;
  }
}

export default HomeCloser;
